<template>
  <div class="container-table saltopagina">
    <q-card class="listadoAcciones" :style="styleCard">
    <q-card-section class="header">
      <div class="titleDetalle text-h6">
        <q-icon class="icon" :name="'img:' + require('@/assets/img/rocket.svg')"></q-icon> Acciones
      </div>
    </q-card-section>

    <q-card-section class = cardTable>
      <q-table
        data-cy="accion-instrumeto-table"
        :data="acciones"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :loading="isLoading"
        :visible-columns="visibleColumns"
      >
        <template v-slot:body-cell-nombre="props">
          <q-td key="nombre" :props="props">
            {{ props.row.nombre }}
          </q-td>
        </template>
        <template v-slot:body-cell-fase="props">
          <q-td key="fase" :props="props">
            <QChipFases :value="props.row.fase.label"/>
          </q-td>
        </template>
        <template v-slot:body-cell-fechaInicio="props">
          <q-td key="fechaInicio" :props="props">
            {{ props.row.fase.fechaInicio | shortDate }}
          </q-td>
        </template>
        <template v-slot:body-cell-fechaFin="props">
          <q-td key="fechaFin" :props="props">
            {{ props.row.fase.fechaFin | shortDate }}
          </q-td>
        </template>
        <template v-slot:body-cell-ver="props">
            <q-td key="ver" :props="props">
                <q-icon
                  :name="'img:' + require('@/assets/img/info.svg')"
                  style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
                  @click="triggerVer(props.row)"
                />
              </q-td>
          </template>
      </q-table>
    </q-card-section>
    </q-card>
    <PopUpDetalleAccion  v-model="showPopUpDetalleAccion" :datosAccion="datosAccion"/>
  </div>
</template>
<script>
import { QTable, QTd, QCardSection } from 'quasar';
import QChipFases from '@/components/PlanAccion/components/QChipFases.vue';
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';
import PopUpDetalleAccion from './PopUpDetalleAccion.vue';
import Loading from '@/components/shared/mixins/Loading.js';

export default {
  mixins: [Loading],
  components: {
    QTable,
    QTd,
    QCardSection,
    QChipFases,
    PopUpDetalleAccion
  },
  props: {
    isLoading: Boolean,
    acciones: Array,
    visibleColumns: Array,
    styleCard: {
      type: String,
      default: () => 'margin: 20px;'
    }
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData'
    })
  },
  data () {
    return {
      pagination: {
        rowsPerPage: 4
      },
      showPopUpDetalleAccion: false,
      datosAccion: [],
      columns: [
        {
          name: 'name',
          label: 'Nombre de la acción',
          align: 'left',
          field: 'name',
          sortable: true,
          style: 'max-width: 250px'
        },
        {
          name: 'fase',
          label: 'Fase',
          align: 'left',
          field: 'label',
          sortable: true
        },
        {
          name: 'fechaInicio',
          label: 'Fecha de inicio',
          align: 'left',
          field: 'fechaInicio',
          sortable: true
        },
        {
          name: 'fechaFin',
          label: 'Fecha de fin',
          align: 'left',
          field: 'fechaFin',
          sortable: true
        },
        {
          name: 'ver',
          label: '',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    async triggerVer (row) {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_ACCION, { idAccion: row.id, idCiudad: this.ciudadSelected.id }).then(async response => {
        this.hideLoading();
        this.datosAccion = response.data;
        this.showPopUpDetalleAccion = true;
      }).catch(() => { this.hideLoading(); });
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  .titleDetalle{
    font-family: DINPro;
    font-weight: bold;
    align-content: center;
    display: flex;
    color: #454545;
    align-items: center !important;
  }
  #title-card-authorization {
    font-family: DINPro;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $azulcabecera;
    display: flex;
    align-items: center;
  }
}
.icon {
  margin-right: 10px;
  font-size: 25px;
}
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }
     .q-table--no-wrap td {
      white-space: normal;
    }

    .cardTable {
      padding: 0px;
      border: solid 3px #e9f4f6;
      border-radius: 12px;
    }
  }
}
</style>
